<template lang="pug">
.container.content-comunicacao
  modal-visualizar-conflito(
    v-if="conflitoSelecionado",
    :conflito="conflitoSelecionado",
    @closeModal="conflitoSelecionado = null"
  )
  .content-conversas.full-width
    .comunicacao-main
      .busca-comunicacao
        search-conflitos(
          @search="search"
          @limpar="handleLimpar"
          :botaoLimpar="true"
        )
  .content-conversas.full-width
    .comunicacao-main
      .listagem-conversas
        app-listagem(
          :has-refresh-button="true",
          :showButtonOrdemServico="false",
          :showButtonAssinatura="false",
          :has-expansivel="false",
          :json-headers="colunas",
          :json-data="items",
          :totalElements="totalElements",
          :pagina="filtroPesquisa.pagina",
          :hasFiltroRapido="false",
          :hasActionButton="false",
          :filtro="filtroPesquisa"
          :infoPrazos="false"
          :headerLabel="'Listagem de processos com conflitos'"
          :showCsvButton="false"
          @atualizarFiltro="atualizarFiltro"
          @updateListagem="search",
          @changePage="changePage",
          @sort="sort",
          @executar="executar"
        )
</template>

<script>
import { mapActions } from 'vuex'
import SearchConflitos from './SearchConflitos'
import AppListagem from '@/components/AppListagem.vue'
import AppPaginacao from '@/components/AppPaginacao'
import ModalVisualizarConflito from '@/screens/ouvidoria/components/ModalVisualizarConflito.vue'

export default {
  components: {
    SearchConflitos,
    AppListagem,
    AppPaginacao,
    ModalVisualizarConflito
  },

  data () {
    return {
      items: [],
      loading: false,
      conflitoSelecionado: null,
      paginaFiltro: {
        pagina: 0,
        tamanhoPagina: 15,
        simplificado: false
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'interessado.cpfCnpj', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'interessado.nomeRazaoSocial', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'statusFormatado', ordem: 4, acoes: [], exibir: () => true },
        { id: 4, titulo: 'Município', propriedade: 'municipio.nome', sortable: true, ordem: 3, acoes: [], exibir: () => true },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataCriacaoFormatada', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipoProcesso.nome', ordem: 5, acoes: [] },
        {
          id: 11, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Adicionar shape', icone: 'fa-pencil-alt', codigo: 'ANALISAR_PROCESSO', ordem: 1, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1 }
          ]
        }
      ],
      totalElements: 0,
      filtroPesquisa: {
        pagina: 0
      }
    }
  },

  methods: {
    ...mapActions({
      getConflitosByFiltro: 'conflito/getConflitosByFiltro'
    }),

    atualizarFiltro (novoFiltro) {
      this.filtro = novoFiltro
    },

    async sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      this.search()
    },

    ANALISAR_PROCESSO (dado) {
      this.$router.push({ name: 'central/ShapeConflitos', params: { id: dado.id } })
    },
    VISUALIZAR_PROCESSO (dado) {
      this.conflitoSelecionado = dado
    },

    executar (config) {
      this[config.acao](config.item)
    },

    async findConversas (filtro) {
      this.loading = true
      this.getConflitosByFiltro(this.filtroPesquisa)
        .then(response => {
          this.items = response.content
          this.totalElements = response.totalElements
          this.loading = false
        })
    },

    search (filtroAtualizado) {
      this.filtroPesquisa = filtroAtualizado
      this.filtroPesquisa = { ...this.filtroPesquisa, ...this.paginaFiltro }

      this.findConversas(this.filtroPesquisa)
    },

    handleLimpar (filtroAtualizado) {
      filtroAtualizado.numeroProcesso = null
      filtroAtualizado.dataCadastro = null
      this.search(filtroAtualizado)
    },

    changePage (newPage) {
      this.paginaFiltro.pagina = newPage - 1
      this.search(this.filtroPesquisa)
    }

  }

}
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
  }
  .full-width {
    width: 100%;
  }
  .toRight {
    padding-right: 2%;
    display: flex;
    justify-content: flex-end;
  }
  .btn-conversa {
    padding: 10px;
    font-size: 12px;
    font-weight: 700;
    margin-right: 23px;
  }
  .content-comunicacao {
    flex: 1;
    padding: 20px;
  }
  .comunicacao-main {
    padding: 10px 0;
  }
  .busca-comunicacao {
    padding: 10px 0;
  }

  @media (max-width: 780px) {
    .content-comunicacao {
      padding: 10px 0 0 10px;
    }

    .comunicacao-main {
    padding: 20px 20px;
    }

    .listagem-conversas {
      position: relative;
      right: 45%;
    }

    .full-width {
      width: 350px;
      position: relative;
      bottom: 65px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/Conflitos.vue